<template>
  <div class="blackout">
    <div class="popup popup-game">
        <game />
    </div>
  </div>
</template>

<script>
import Game from "@/components/GameChick/Game"
export default {
  components:{
    Game
  }
}
</script>


<style lang="less" scoped>
  .popup.popup-game{
    width: 90vw;
    background: none;
  }
</style>
